import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
const Activity = () => {
  const fillterData = [
    { id: 1, title: "Activity Senior", img: "https://webapi.entab.info/api/image/SJCSQP/public/Images/activity1.jpg", link: "/" },
    { id: 2, title: "Activity Junior", img: "https://webapi.entab.info/api/image/SJCSQP/public/Images/activity2.jpg", link: "/" },
    { id: 3, title: "Sports Senior", img: "https://webapi.entab.info/api/image/SJCSQP/public/Images/activity3.jpg", link: "/" },
    { id: 4, title: "Sports Junior", img: "https://webapi.entab.info/api/image/SJCSQP/public/Images/activity4.jpg", link: "/" },
    { id: 5, title: "Media", img: "https://webapi.entab.info/api/image/SJCSQP/public/Images/activity5.jpg", link: "/" },
    { id: 6, title: "Special", img: "https://webapi.entab.info/api/image/SJCSQP/public/Images/activity6.jpg", link: "/" },
    { id: 7, title: "Alumni", img: "https://webapi.entab.info/api/image/SJCSQP/public/Images/activity7.jpg", link: "/" },
    { id: 8, title: "Memories", img: "https://webapi.entab.info/api/image/SJCSQP/public/Images/activity8.jpg", link: "/" },
  ];

  const category = [
    "All", "Activity Senior", "Activity Junior", "Sports Senior", "Sports Junior", "Media", "Special", "Alumni", "Memories"
  ];

  const [selectedCategory, setSelectedCategory] = useState("All");

  // Filter based on category
  const filtered = selectedCategory === "All"
    ? fillterData
    : fillterData.filter(item => item.title === selectedCategory);

  return (
    <>
      <div className="activitybtn">
        {category.map((item, index) => (
          <button
            type="button"
            key={index}
            onClick={() => setSelectedCategory(item)}
            className={selectedCategory === item ? 'active' : ''}
          >
            {item}
          </button>
        ))}
      </div>

      <div className="filterdata">
        {filtered.map((item) => ( 
                <div key={item.id} className="filterdatadiv"> 
                    <div className='img-block'>
                        <LazyLoad><img src={item.img} className="img-fluid"/></LazyLoad>
                    </div> 
                    <div className='content-blk'>
                        <h3>{item.title}</h3>
                        <button className="button"><Link to={item.link}> Read More <img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/arrowicn.png" className="img-fluid"/></Link></button>
                    </div>
                </div> 
          ))}
         
      </div>
    </>
  );
};

export default Activity;
